import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { p, selectObjects } from "~/misc/common";

export default class extends Controller {
	async connect() {
		console.log('initContractsForm');

		const relationships = $('#toJs').data('relationships');
		p(relationships);

		refresh();
		$('#contract_relationship_id').on('change', refresh);

		function refresh() {
			const relationship = selectObjects(relationships, 'id', $('#contract_relationship_id').myGetNumValue())[0];
			if (relationship && relationship.code == 12) {
				$('.employee').show(400);
			} else {
				$('.employee').hide(400);
			}
		}
	}
}
